// admin/layout/AdminLayout.jsx
import React from "react";
import AdminSidebar from "./AdminSidebar";
import Header from "../../common/Header";
import Footer from "../../common/Footer";
import { Outlet } from "react-router-dom";

const AdminLayout = ({ collapsed, setCollapsed }) => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50 dark:bg-gray-900">
      <Header />

      <div className="flex flex-1 pt-[72px]">
        <AdminSidebar collapsed={collapsed} setCollapsed={setCollapsed} />

        <div className="flex-1 flex flex-col min-w-0">
          <main className="flex-1 p-6 md:p-8">
            <div className="max-w-[1300px] mx-auto">
              <Outlet />
            </div>
          </main>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AdminLayout;
